const COMMENTS = [
  {
    name: '追剧达人小陈',
    text: '妖精视频真的太方便了！以前要切换好几个平台找想看的剧，现在一个页面就能看到香蕉视频、蜜桃视频、西瓜视频所有更新，省了好多时间。画质也很清晰，播放一点都不会卡。',
    time: '2天前',
  },
  {
    name: '电影爱好者阿琳',
    text: '作为电影发烧友，妖精视频的电影聚合功能简直是我的福音。蜜桃视频的院线新片、樱花视频的经典动漫、蘑菇视频的老片修复，所有内容一目了然，每天都要来刷一刷看有什么新内容上线。',
    time: '5天前',
  },
  {
    name: '综艺迷小王',
    text: '西瓜视频的《欢乐大本营》新一季太搞笑了！通过妖精视频才知道已经开播了，差点错过。现在每天都会来看看最新动态，七个平台的内容更新都不会漏，推荐给所有追剧追综的朋友！',
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          用户心声
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          听听影迷朋友们怎么说
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-secondary-600 font-medium text-sm">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
              <div className="flex items-center gap-1 mt-3 text-secondary-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}